import Player from './output/index.jsx';

export { Player };
